module.exports = __webpack_public_path__ + "static/media/bh.2e9ade13.svg";